var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('span',[_vm._v("Rows: ")]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.countDisplay))])])
}
var staticRenderFns = []

export { render, staticRenderFns }